// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8592) return "static/chunks/common-e3d2b53a5d05bf48.js";
	if (chunkId === 5522) return "static/chunks/ui-7babe74be84e515a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"60":"eb02c5dceffcc9f5","706":"91272e24c0f9033a","759":"fac09ba6e521f458","1340":"4ddd07416cf04963","2971":"0ffc01551430afc1","3193":"b00137fce3d3c0cc","3813":"04176145bbc438ab","4459":"b8e4de53fc9af3c8","9501":"c22c4cb631bcda8c","9727":"d3a61647faf38ad5"}[chunkId] + ".js";
};